module.exports = __webpack_public_path__ + "static/media/broxel-horizontal-spa.463d155c.png";